:host {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    position: relative;
}

.node {
    color: var(--color-layout-contrast);
    padding: 6px 20px 6px 48px;
    text-align: left;

    &::after {
        content: '';
        display: block;
        position: absolute;
        margin: auto;
        top: 0;
        right: unset;
        bottom: 0;
        left: 29px;
        width: 2px;
        height: auto;
        background-color: var(--color-layout-base);
        transition: background-color 500ms ease;
    }

    &:hover,
    &:focus {
        color: var(--color-layout-highlight);
    }

    &[disabled] {
        &:hover,
        &:focus,
        & {
            color: var(--color-layout-contrast);
        }
    }
}

:host(.active_within) .node::after,
.link-active.node::after {
    background-color: var(--color-layout-highlight);
}
